import { render, staticRenderFns } from "./DefaultWrapper.vue?vue&type=template&id=26903dc0&scoped=true&"
var script = {}
import style0 from "./DefaultWrapper.vue?vue&type=style&index=0&id=26903dc0&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26903dc0",
  null
  
)

export default component.exports